<template>
<button class="custom-button" :class="{ secondary: variant === 'secondary' }" :type="btnType" @click="$emit('click')">
	<div class="custom-button__slot">
		<slot></slot>
	</div>
</button>
</template>

<script>
  export default {
	props:{
		btnType: String,
		disable: Boolean,
		variant: String
	}
  }
</script>

<style lang="scss" scoped>
@import './../../styles/variables.scss';
.custom-button {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: white;
	font-size: 18px;
	min-width: 50px;
	height: 50px;
	border: none;
	border-radius: 50%;
	background-color: #3a3bf8;
	box-shadow: 0px 5px 10px -1px rgba(0, 0, 0, 0.25);
	transition: background-color 200ms;
	outline: none;
	cursor: pointer;

	&.secondary {
		background-color: #c4c4c4;

		.dark & {
			background-color: $dark-text;
		}
	}

	&:hover {
		background-color: white;
	}

	&:hover .custom-button__slot{
		transform: scale(1.2);
		color: #3a3bf8;
		path {
			fill: #3a3bf8;
		}
	}

	&__slot {
		position: relative;
		display: flex;
		transform: scale(1);
		transition: all 200ms;

		svg {
			width: 25px;
			height: 25px;
			fill: white;
		}
	}
}

</style>
